export const correctionBelongsToTitles = {
  order: 'Salg',
  refund: 'Refundering',
  incoming_txn_sales_channel: 'Betaling (salgskanal)',
  incoming_txn_gateway: 'Betaling (gateway)',
  incoming_txn_gift_card: 'Betaling (gavekort)',
  outgoing_txn_sales_channel: 'Tilbagebetaling (salgskanal)',
  outgoing_txn_gateway: 'Tilbagebetaling (gateway)',
  outgoing_txn_gift_card: 'Tilbagebetaling (gavekort)',
  correction: 'Korrektion',
};
